export default "__VITE_ASSET__ec8rARmI__"